document.addEventListener("DOMContentLoaded", () => {
    const el = document.getElementById("mapa");
    if (!el) return;

    if (typeof mapResultatsEntries !== "undefined") {
        initResultsMap(el, mapResultatsEntries);
    } else if (typeof mapProviderZone !== "undefined") {
        initZoneMap(el);
    }
});

// ---------------- MAP BASE ----------------
function createMap(container, center, zoom) {
    return new google.maps.Map(container, {
        center,
        zoom,
        styles: mapStyle,
        streetViewControl: false,
        scrollwheel: false
    });
}

// ---------------- POPUP CUSTOM ----------------
class CustomPopup extends google.maps.OverlayView {
    constructor(position, content) {
        super();
        this.position = position;

        this.container = document.createElement("div");
        this.container.className = "custom-popup";

        this.container.innerHTML = `
            <div class="popup-content">
                <button class="popup-close" aria-label="Close"></button>
                <div class="popup-body">
                    ${content}
                </div>
            </div>
        `;

        this.container.querySelector(".popup-close")
            .addEventListener("click", () => this.setMap(null));
    }

    onAdd() {
        this.getPanes().floatPane.appendChild(this.container);
    }

    draw() {
        const projection = this.getProjection();
        const pos = projection.fromLatLngToDivPixel(this.position);

        if (pos) {
            this.container.style.left = pos.x + "px";
            this.container.style.top = pos.y + "px";
        }
    }

    onRemove() {
        this.container?.remove();
    }
}

// ---------------- RESULTS MAP ----------------
function initResultsMap(container, entries) {
    const bounds = new google.maps.LatLngBounds();
    const center = typeof mapCenter !== "undefined"
        ? mapCenter
        : { lat: 41.6, lng: 1.7 };

    const zoom = typeof mapZoom !== "undefined" ? mapZoom : 8;

    const map = createMap(container, center, zoom);

    const svg = document.getElementById("svgCloud")?.innerHTML || "";
    const icon = {
        url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(45, 45),
        anchor: new google.maps.Point(20, 47)
    };

    let activePopup = null;

    const markers = entries.map(entry => {
        const marker = new google.maps.Marker({
            position: entry.location,
            icon
        });

        if (marker.getPosition()) {
            bounds.extend(marker.getPosition());
        }

        marker.addListener("click", () => {
            if (activePopup) activePopup.setMap(null);

            activePopup = new CustomPopup(marker.getPosition(), entry.content);
            activePopup.setMap(map);

            map.panTo(marker.getPosition());
        });

        return marker;
    });

    // ---------------- CLUSTER MODERN + ICONS m1-m5 ----------------
    new markerClusterer.MarkerClusterer({
        map,
        markers,
            renderer: {
                render: ({ count, position }) => {
                    let img = "/media/img/markerclusterer/m1.png";
                    let size = 52;

                    if (count < 10) {
                        img = "/media/img/markerclusterer/m1.png";
                        size = 52;
                    } else if (count < 50) {
                        img = "/media/img/markerclusterer/m2.png";
                        size = 56;
                    } else if (count < 100) {
                        img = "/media/img/markerclusterer/m3.png";
                        size = 66;
                    } else if (count < 200) {
                        img = "/media/img/markerclusterer/m4.png";
                        size = 78;
                    } else {
                        img = "/media/img/markerclusterer/m5.png";
                        size = 90;
                    }

                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: img,
                            scaledSize: new google.maps.Size(size, size),
                            anchor: new google.maps.Point(size / 2, size / 2)
                        },
                        label: {
                            text: String(count),
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "bold"
                        }
                    });
                }
            }
    });

    if (!bounds.isEmpty()) {
        map.fitBounds(bounds);
    }

    window.addEventListener("resize", () => {
        if (!bounds.isEmpty()) map.fitBounds(bounds);
    });

    map.addListener("click", () => {
        if (activePopup) activePopup.setMap(null);
    });
}

// ---------------- ZONE MAP ----------------
function initZoneMap(container) {
    const pos = {
        lat: parseFloat(mapProviderZone.coordenades_lat),
        lng: parseFloat(mapProviderZone.coordenades_lng)
    };

    const map = new google.maps.Map(container, {
        center: pos,
        zoom: 8,
        styles: mapStyle,
        disableDefaultUI: true,
        draggable: false
    });

    const marker = new google.maps.Marker({
        position: pos,
        map,
        icon: {
            url: "/media/img/markerclusterer/m1.png",
            scaledSize: new google.maps.Size(52, 52),
            anchor: new google.maps.Point(26, 26)
        }
    });

    marker.addListener("click", () => {
        window.location.href = mapZoneURL;
    });
}

// ---------------- STYLE ----------------
const mapStyle = [
    // =====================
    // GLOBAL (base neta)
    // =====================
    {
        featureType: "all",
        elementType: "geometry",
        stylers: [{ color: "#f7f7f7" }]
    },

    // =====================
    // LANDSCAPE
    // =====================
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }]
    },

    // =====================
    // POINTS OF INTEREST (apagat)
    // =====================
    {
        featureType: "poi",
        stylers: [{ visibility: "off" }]
    },

    // =====================
    // CARRETERES (NETES I UNIFORMES)
    // =====================
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#e6e6e6" }]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#dcdcdc" }]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#e6e6e6" }]
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#f2f2f2" }]
    },

    // Text carreteres (molt suau)
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#9a9a9a" }]
    },
    {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [{ color: "#ffffff" }]
    },

    // =====================
    // TRANSPORT (ocult)
    // =====================
    {
        featureType: "transit",
        stylers: [{ visibility: "off" }]
    },

    // =====================
    // AIGUA (gris elegant, NO blau)
    // =====================
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#e9e9e9" }]
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#9e9e9e" }]
    },

    // =====================
    // LÍMITS ADMINISTRATIUS (molt subtil)
    // =====================
    {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [{ color: "#dcdcdc" }]
    },
    {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#8a8a8a" }]
    }
];